export enum WhiteboardDataStatus {
  "ERROR" = "ERROR",
  "IN_PROGRESS" = "IN_PROGRESS",
  "NOT_STARTED" = "NOT_STARTED",
  "SUCCESS" = "SUCCESS",
}

export const MAX_CREATE_ATTEMPTS = 5;
